import { DataObject } from '@mui/icons-material';

import List from './List';
import Create from './Create';
import Edit from './Edit';
import { ResourceDefinition, ResourceSections } from 'src/types';

export const ApiFieldsResource: ResourceDefinition = {
  name: 'api_fields',
  section: ResourceSections.DATA_PACKAGES,
  icon: DataObject,
  options: { label: 'API Fields' },

  list: List,
  create: Create,
  edit: Edit,

  permissions: {
    list: ['apiField:read'],
    create: ['apiField:edit'],
    edit: ['apiField:edit'],
  },
};
